<template>
  <div class="q-gutter-y-sm">
    <q-item clickable class="item" active-class="item-active" to="/orders/rfq">
      <q-item-section avatar>
        <q-icon size="md"><RfqIcon /></q-icon>
      </q-item-section>

      <q-item-section>RFQ</q-item-section>

      <q-tooltip anchor="center right" self="center left">RFQ</q-tooltip>
    </q-item>

    <q-item clickable class="item" active-class="item-active" to="/orders/bookings">
      <q-item-section avatar>
        <q-icon size="md"><BookingIcon /></q-icon>
      </q-item-section>

      <q-item-section>Bookings</q-item-section>

      <q-tooltip anchor="center right" self="center left">Bookings</q-tooltip>
    </q-item>

    <q-item clickable class="item" active-class="item-active" to="/orders/invoices">
      <q-item-section avatar>
        <q-icon size="md"><ReportIcon /></q-icon>
      </q-item-section>

      <q-item-section>Invoices</q-item-section>

      <q-tooltip anchor="center right" self="center left">Invoices</q-tooltip>
    </q-item>

    <q-item clickable class="item" active-class="item-active" to="/orders/payment">
      <q-item-section avatar>
        <q-icon size="md"><PaymentIcon /></q-icon>
      </q-item-section>

      <q-item-section>Payment</q-item-section>

      <q-tooltip anchor="center right" self="center left">Payment</q-tooltip>
    </q-item>

    <q-item clickable class="item" active-class="item-active" to="/orders/statistics">
      <q-item-section avatar>
        <q-icon size="md"><CalendarIcon /></q-icon>
      </q-item-section>

      <q-item-section>Statistics-Summary</q-item-section>

      <q-tooltip anchor="center right" self="center left">Statistics-Summary</q-tooltip>
    </q-item>

    <q-item clickable class="item" active-class="item-active" to="/orders/history">
      <q-item-section avatar>
        <q-icon size="md"><HistoryIcon /></q-icon>
      </q-item-section>

      <q-item-section>Booking History</q-item-section>

      <q-tooltip anchor="center right" self="center left">Booking History</q-tooltip>
    </q-item>
  </div>
</template>

<script>
import RfqIcon from '@/assets/icons/rfq.svg';
import BookingIcon from '@/assets/icons/booking.svg';
import ReportIcon from '@/assets/icons/report.svg';
import PaymentIcon from '@/assets/icons/payment.svg';
import CalendarIcon from '@/assets/icons/calendar.svg';
import HistoryIcon from '@/assets/icons/history.svg';

export default {
  components: {
    RfqIcon,
    BookingIcon,
    ReportIcon,
    PaymentIcon,
    CalendarIcon,
    HistoryIcon,
  },
};
</script>
